import { Component, OnInit } from '@angular/core';
import { SettingsService } from '../../core/settings/settings.service';
import {RouteConfigLoadEnd, RouteConfigLoadStart, Router} from '@angular/router';
import {BlockUI, NgBlockUI} from 'ng-block-ui';

declare const window: any;

@Component({
    selector: '[app-footer]',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

    // Decorator wires up blockUI instance
    @BlockUI() blockUI: NgBlockUI;

    status = 'ONLINE';
    isConnected = true;
    blocked: boolean;

    constructor(private router: Router, public settings: SettingsService) {
      this.router.events.subscribe(event => {
        if (event instanceof RouteConfigLoadStart) {
          this.blocked = true;
          this.blockUI.start('Loading...'); // Start blocking
        } else if (event instanceof RouteConfigLoadEnd) {
          this.blocked = false;
          this.blockUI.stop(); // Stop blocking
        }
      });
      window.addEventListener('online', () => {this.isConnected = false; this.status = 'YONLINE';});
      window.addEventListener('offline', () => {this.isConnected = true; this.status = 'YOUR ARE OFFLINE';});
    }

    ngOnInit() { }

    get isOnline() {
      return !!window.navigator.onLine;
    }
}
